import { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { motion } from 'framer-motion';
import { useDispatch, useSelector } from "react-redux";

import store from "../redux/store";
import * as actions from "../redux/settings/settingsTypes";
import VerticalLayout from "../layout/VerticalLayout";
import HorizontalLayout from "../layout/HorizontalLayout";
import FullLayout from "../layout/FullLayout";
import Home from "../view/dashboard";
import Error404 from "../view/pages/errors/404";
import { theme } from "../redux/customise/customiseActions";
import { Routes } from "./routes";

export default function Router() {
    const customise = useSelector(state => state.customise);
    const dispatch = useDispatch();

    useEffect(() => {
        document.querySelector("body").classList.add(customise.theme);
        dispatch(theme(customise.theme));
    }, []);

    useEffect(() => {
        if (customise.direction == "ltr") {
            document.querySelector("html").setAttribute("dir", "ltr");
        }
        else if (customise.direction == "rtl") {
            document.querySelector("html").setAttribute("dir", "rtl");
        };
    }, []);

    const DefaultLayout = customise.layout;
    const Layouts = { VerticalLayout, HorizontalLayout, FullLayout };

    const LayoutRoutesAndPaths = (layout) => {
        const LayoutRoutes = [];
        const LayoutPaths = [];
        if (Routes) {
            Routes.filter(route => (route.layout === layout) && (
                LayoutRoutes.push(route),
                LayoutPaths.push(route.path)
            ));
        };

        return { LayoutRoutes, LayoutPaths };
    };

    const ResolveRoutes = () => {
        return Object.keys(Layouts).map((layout, index) => {
            const { LayoutRoutes, LayoutPaths } = LayoutRoutesAndPaths(layout);

            let LayoutTag;
            if (DefaultLayout == "HorizontalLayout") {
                if (layout == "VerticalLayout") {
                    LayoutTag = Layouts["HorizontalLayout"];
                }
                else {
                    LayoutTag = Layouts[layout];
                };
            }
            else {
                LayoutTag = Layouts[layout];
            };

            return (
                <Route path={LayoutPaths} key={index}>
                    <LayoutTag>
                        <Switch>
                            {LayoutRoutes.map((route) => {
                                return (
                                    <Route
                                        key={route.path}
                                        path={route.path}
                                        exact={route.exact === true}
                                        render={(props) => {
                                            store.dispatch({ type: actions.SET_PAGE_ROUTE, payload: route.path });
                                            return (
                                                <Suspense fallback={null}>
                                                    {route.layout === 'FullLayout' ?
                                                        (<route.component {...props} />)
                                                        : (<motion.div
                                                            initial={{ opacity: 0, y: 10 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ type: "spring", duration: 0.2, delay: 0.2 }}
                                                        >
                                                            <route.component {...props} />
                                                        </motion.div>)}
                                                </Suspense>);
                                        }}
                                    />
                                );
                            })}
                        </Switch>
                    </LayoutTag>
                </Route >
            );
        });
    };

    return (
        <BrowserRouter>
            <Switch>
                <Route exact path={'/'} render={() => (DefaultLayout == "HorizontalLayout" ?
                    (<Layouts.HorizontalLayout><Home /></Layouts.HorizontalLayout>)
                    : (<Layouts.VerticalLayout><Home /></Layouts.VerticalLayout>))}
                />
                {ResolveRoutes()}
                <Route path='*'>
                    <Error404 />
                </Route>
            </Switch>
        </BrowserRouter>
    );
};